<template>
  <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="204px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
    <!-- 公司名称 -->
    <div class="pt50 messageWrap companyWrap">
      <p class="messageTitle">
        {{ $t("enroll.intitle.companyNameTitle") }}
      </p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.companyName01')" prop="proposedCompanyName1" ref="proposedCompanyName1">
          <el-input v-model="dataForm.proposedCompanyName1" :placeholder="$t('common.placeholder.enter')" class="wd340" v-regexFilter="$halfWidthRegex"></el-input>
          <el-form-item prop="proposedCompanyType1" ref="proposedCompanyType1" class="inlineSuffix">
            <el-select v-model="dataForm.proposedCompanyType1" class="wd160">
              <el-option v-for="name in companySuffixList" :key="`suffix01-${name}`" :label="name" :value="name"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('enroll.intitle.companyName02')" prop="proposedCompanyName2" ref="proposedCompanyName2">
          <el-input v-model="dataForm.proposedCompanyName2" :placeholder="$t('common.placeholder.enter')" class="wd340" v-regexFilter="$halfWidthRegex"></el-input>
          <el-form-item prop="proposedCompanyType2" ref="proposedCompanyType2" class="inlineSuffix">
            <el-select v-model="dataForm.proposedCompanyType2" class="wd160">
              <el-option v-for="name in companySuffixList" :key="`suffix02-${name}`" :label="name" :value="name"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('enroll.intitle.companyName03')" prop="proposedCompanyName3" ref="proposedCompanyName3">
          <el-input v-model="dataForm.proposedCompanyName3" :placeholder="$t('common.placeholder.enter')" class="wd340" v-regexFilter="$halfWidthRegex"></el-input>
          <el-form-item prop="proposedCompanyType3" ref="proposedCompanyType3" class="inlineSuffix">
            <el-select v-model="dataForm.proposedCompanyType3" class="wd160">
              <el-option v-for="name in companySuffixList" :key="`suffix03-${name}`" :label="name" :value="name"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="">
          <p class="fs12 lh16 crgy919 wd500 taj">
            {{ $t("enroll.intitle.malaysia.businessExplain") }}
          </p>
        </el-form-item>
      </div>
    </div>

    <!-- 业务性质 - 业务描述 -->
    <div class="pt50 pb22 messageWrap">
      <p class="messageTitle">{{ $t("enroll.intitle.main") }}</p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.establish.malaysia.msicCodes')" prop="msicCodes" ref="msicCodes">
          <el-select v-model="dataForm.msicCodes" multiple :multiple-limit="3" filterable :placeholder="$t('common.placeholder.select')" class="wd500" popper-class="tradeWrap">
            <el-option v-for="(item, index) in getTradeNewFormatList" :key="`msic-${index}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('enroll.establish.malaysia.businessDescription')" prop="businessDescription" ref="businessDescription">
          <el-input
            type="textarea"
            :rows="4"
            v-model="dataForm.businessDescription"
            :placeholder="$t('common.placeholder.enter')"
            class="wd500"
            maxlength="78"
            show-word-limit
            v-regexFilter="$halfWidthRegex"
          ></el-input>
          <p class="pt10 fs12 lh16 crgy919 wd500 taj">
            {{ $t("enroll.intitle.commonDescribe") }}
          </p>
        </el-form-item>
      </div>
    </div>

    <!-- 股东/董事信息 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.intitle.detailsTitle") }}</p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.detailsTitleLower')" prop="companyMemberList" ref="companyMemberList">
          <shareholder-director-information v-model="dataForm.companyMemberList" ref="shareholderDirectorInformationRef" :isReadonly="isReadonly" :isMalaysia="true" />
        </el-form-item>
        <el-form-item label="" prop="hasNomineeDirector" ref="hasNomineeDirector" class="agreementWrap" v-if="applymentHasNomineeDirector">
          <el-checkbox v-model="dataForm.hasNomineeDirector" :true-label="1" :false-label="0">{{ $t("enroll.intitle.malaysia.check") }}</el-checkbox>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import ShareholderDirectorInformation from "../../components/ShareholderDirectorInformation";
import { validateLocation, strToNum } from "@/utils/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";

// MSIC 多选代码的分隔符（ASCII Unit Separator，避免与描述中的逗号/分号/斜杠冲突）
const MSIC_SEP = "\x1F";

export default {
  name: "EnrollIntitleMalaysia",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShareholderDirectorInformation,
  },
  mixins: [validatorMixin],
  data() {
    return {
      dataForm: {
        proposedCompanyName1: null,
        proposedCompanyType1: null,
        proposedCompanyName2: null,
        proposedCompanyType2: null,
        proposedCompanyName3: null,
        proposedCompanyType3: null,
        businessDescription: null,
        msicCodes: [],
        companyMemberList: [],
        hasNomineeDirector: null,
      },
      rules: {
        proposedCompanyName1: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        proposedCompanyType1: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        proposedCompanyName2: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        proposedCompanyType2: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        proposedCompanyName3: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        proposedCompanyType3: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        // businessDescription: [
        //   {
        //     required: true,
        //     message: this.$t("common.placeholder.enter"),
        //     trigger: "submit",
        //   },
        // ],
        msicCodes: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        companyMemberList: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.replenish"),
            trigger: "submit",
          },
        ],
        hasNomineeDirector: [
          {
            required: true,
            validator: this.validateMustCheckbox,
            trigger: "submit",
          },
        ],
      },
      companySuffixList: ["Sdn. Bhd."], // 公司名称后缀列表
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasNomineeDirector"]),
    ...mapGetters("constant", ["globalFormatList", "getTradeNewFormatList"]),
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 数据初始化处理
    dataInit() {
      const detail = JSON.parse(JSON.stringify(this.applymentDetail));
      // 字段名已与接口一致，直接取值
      this.dataForm = {
        proposedCompanyName1: detail.proposedCompanyName1 || null,
        proposedCompanyType1: detail.proposedCompanyType1 || null,
        proposedCompanyName2: detail.proposedCompanyName2 || null,
        proposedCompanyType2: detail.proposedCompanyType2 || null,
        proposedCompanyName3: detail.proposedCompanyName3 || null,
        proposedCompanyType3: detail.proposedCompanyType3 || null,
        businessDescription: detail.businessDescription,
        msicCodes: detail.msicCodes ? detail.msicCodes.split(MSIC_SEP) : [],
        companyMemberList: detail.companyMemberList || [],
        hasNomineeDirector: strToNum(detail.hasNomineeDirector),
      };
    },
    // 获取提交参数(由父级触发) - 含业务校验
    getParamsData() {
      // 公司名不能包含后缀
      let suffixList = this.companySuffixList;
      for (let i in suffixList) {
        if (this.dataForm.proposedCompanyName1 != null && this.dataForm.proposedCompanyName1.indexOf(suffixList[i]) != -1) {
          this.$message.warning(this.$t("enroll.intitle.businessExplain"));
          validateLocation({ proposedCompanyName1: {} }, this);
          return false;
        }

        if (this.dataForm.proposedCompanyName2 != null && this.dataForm.proposedCompanyName2.indexOf(suffixList[i]) != -1) {
          this.$message.warning(this.$t("enroll.intitle.businessExplain"));
          validateLocation({ proposedCompanyName2: {} }, this);
          return false;
        }

        if (this.dataForm.proposedCompanyName3 != null && this.dataForm.proposedCompanyName3.indexOf(suffixList[i]) != -1) {
          this.$message.warning(this.$t("enroll.intitle.businessExplain"));
          validateLocation({ proposedCompanyName3: {} }, this);
          return false;
        }
      }

      return {
        ...this.dataForm,
        msicCodes: this.dataForm.msicCodes.join(MSIC_SEP),
      };
    },
    // 触发必填校验(由父级触发) - 仅下一步时调用
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            // 校验股东/董事信息
            if (this.$refs.shareholderDirectorInformationRef && !this.$refs.shareholderDirectorInformationRef.validate()) {
              reject("custom prompt: Shareholder/Director validation failed");
              return;
            }
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>

<style lang="scss" scoped>
.dataForm ::v-deep {
  .el-form-item__label {
    height: 38px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: left;
    /* word-break: break-all; */
  }
}

.messageTitle {
  /* border-left: 2px solid #409eff; */
  border-radius: 2px;
  font-size: 16px;
  /* padding-left: 6px; */
  line-height: 1em;
  font-weight: 600;
}

.prependInput ::v-deep {
  .el-input-group__prepend {
    background: #fff;
  }
}

.lineFeed {
  white-space: initial !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  height: auto !important;
  line-height: 22px;
  padding-top: 4px;
  text-align: justify;
}

.agreementWrap {
  ::v-deep {
    .el-checkbox__label {
      width: 98%;
      white-space: initial;
      /* word-wrap: break-word; */
      /* word-break: break-all; */
      font-size: 14px;
      vertical-align: top;
      margin-top: 8px;
    }
  }
}

.companyWrap {
  ::v-deep {
    .el-input {
      vertical-align: middle;
    }

    .el-select {
      .el-input__inner {
        font-size: 12px;
      }
    }

    /* 嵌套的后缀选择器 form-item：行内显示，无标签、无额外边距 */
    .inlineSuffix {
      display: inline-block;
      margin-bottom: 0;
    }
  }
}
</style>
